import type { ContragentResponse, LoginSuccessResponse, RefreshTokenRequest, RoleResponse, UserLoginRequest, UserResponse } from '@/types'

import { authHttp } from '@/http'
import { getBearerToken } from '@/services/localStorage'

export async function fetchLogin({ login, password }: UserLoginRequest): Promise<LoginSuccessResponse> {
  const response = await authHttp.post<LoginSuccessResponse>('/Auth/login', { login, password })
  return response ?? {} as LoginSuccessResponse
}

export async function fetchRefreshToken(data: RefreshTokenRequest): Promise<LoginSuccessResponse> {
  const response = await authHttp.post<LoginSuccessResponse>('/Auth/refreshtoken', data)
  return response ?? {} as LoginSuccessResponse
}

export async function fetchLogout(data: RefreshTokenRequest) {
  await authHttp.post('/Auth/logout', data, {
    headers: { Authorization: getBearerToken() },
  })
}

export async function fetchUserInfo(): Promise<UserResponse> {
  const response = await authHttp.get<UserResponse>('/Users/user-info')
  return response ?? {} as UserResponse
}

export async function fetchUserItems(ids: string[]): Promise<UserResponse[]> {
  const response = await authHttp.post<UserResponse[]>('/Users/byGuidArray', ids)
  return response ?? []
}

export async function fetchByIdUserItems(ids: number[]): Promise<UserResponse[]> {
  const response = await authHttp.post<UserResponse[]>('/Users/byIdRange', ids)
  return response ?? []
}

export async function getAllUserItems(filter?: any): Promise<UserResponse[]> {
  const response = await authHttp.get<UserResponse[]>('users/items', { params: filter })
  return response ?? []
}

export async function fetchContragentItems(): Promise<ContragentResponse[]> {
  const response = await authHttp.get<ContragentResponse[]>('/Contragents/all')
  return response ?? []
}

export async function fetchRoles(): Promise<RoleResponse[]> {
  const response = await authHttp.get<RoleResponse[]>('/Roles/all')
  return response ?? []
}
